<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      
      <header v-text="datas.business.name"></header>
      <div class="swiper-container banner" v-if="datas.focus && datas.focus_pics_is_show == 1">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
        </div>
      </div>

      <section class="mainBox">
        <div class="csixBox">
          <div class="csixHead">二维码信息</div>
          <div class="csixMain">
            <p>单元识别码</p>
            <p class="codeId" v-text="code"></p>
          </div>
          <div class="csixMain">
            <p>首次扫码时间</p>
            <p v-text="datas.scan_first_time"></p>
          </div>
          <div class="csixMain">
            <p>扫描次数</p>
            <p v-text="datas.scan_count"></p>
          </div>
          
          <div class="csixHead">产品信息</div>
          <div class="csixMain">
            <p>登记证号</p>
            <p v-text="datas.product.reg_code_str"></p>
          </div>
          <div class="csixMain">
            <p class="leftWidth">登记证持有人名称</p>
            <p v-text="datas.product.reg_code_owner"></p>
          </div>
          <div class="csixMain">
            <p>产品名称</p>
            <p v-text="datas.product.name"></p>
          </div>
          <div class="csixMain">
            <p>农药名称</p>
            <p v-text="datas.product.alias_name"></p>
          </div>
          <div class="csixMain">
            <p>保质期</p>
            <p v-text="datas.product.period"></p>
          </div>
          <div class="csixMain">
            <p>规格</p>
            <p v-text="datas.product.unit"></p>
          </div>
          <div class="csixMain" v-if="datas.attribute && datas.attribute.ship_date">
            <p>生产日期</p>
            <p v-text="datas.attribute.ship_date"></p>
          </div>
          <div class="csixMain" v-if="datas.product.attribute && (val.key || val.value)" v-for="val in datas.product.attribute">
            <p v-text="val.key"></p>
            <p v-text="val.value"></p>
          </div>
          <!-- <div class="csixMain">
            <p>生产日期</p>
            <p>{{product_date}}</p>
          </div> -->
          <div class="csixMain" v-if="datas.batch && datas.batch.name">
            <p>生产批次</p>
            <p v-text="datas.batch.name"></p>
          </div>
          
          <!-- {{each product.custom as index}}
            {{each index.data as value}}
              <div class="csixMain">
                <p>{{value.name}}</p>
                <p>{{value.value}}</p>
              </div>
            {{/each}}
          {{/each}} -->
          
          <div class="csixMain">
            <p>追溯网址</p>
            <p class="skip">https://sy.oid.plus</p>
          </div>
          
          <div class="csixMain" v-if="datas.product.introduce">
            <p>产品描述</p>
            <p>{{datas.product.introduce}}</p>
          </div>
          
          <div class="csixHead">企业信息</div>
          <div class="csixMain">
            <p>企业名称</p>
            <p>{{datas.business.name}}</p>
          </div>
          <div class="csixMain" v-if="datas.business.address">
            <p>企业地址</p>
            <p>{{datas.business.address}}</p>
          </div>
          <div class="csixMain" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data">
            <p v-text="val.key"></p>
            <p v-text="val.value"></p>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Pesticide03',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      count:2,
      datas:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      Music:{
        url:null,
        type:false
      }
    }
  },
  created () {
    self = this;

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

    document.title = "农药二维码追溯系统";  //设置页面标题
    document.body.style.backgroundColor = "#f3f3f3";
  },
  updated () {
    
  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){
        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
        //自定义属性
        if(response.data.meta.activation_a){
          datas.attribute = JSON.parse(response.data.meta.activation_a);
        }
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //产品自定义属性
        if (datas.product.attribute) {
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }
        //企业自定义属性
        if (datas.business.customize_data) {
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;
        self.datas = datas;

        self.$nextTick(() => {
          new Swiper('.banner',{
            autoplay: {
              delay: 3000
            },
            loop : true,
          })
        })

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    }
  }
}
</script>

<style scoped>
  header{
    width: 100%;
    color: #fff;
    padding: 13px 0;
    font-size: 20px;
    text-align: center;
    background-color: #317ef3;
  }
  .banner{
    background-color: #fff;
  }
  .banner img{
    display: block;
    width: 100%;
  }
  .mainBox{
    padding:0 15px 15px 15px;
  }
  .csixHead{
    color:#fff;
    background-color: #317ef3;
    padding:5px 20px;
    margin-top:15px;
    font-size:15px;
    border-radius: 0 0 10px 10px;
  }
  .csixMain{
    overflow: hidden;
    font-size:14px;
    background-color: #fff;
    margin-top:10px;
    border-radius: 10px;
    text-align: center;
  }
  .csixMain p{
    float: left;
    padding:5px 0;
    line-height:25px;
  }
  .csixMain p:first-child{
    width: 125px;
  }
  .csixMain p:last-child{
    border-left:1px solid #f3f3f3;
    padding:5px 10px;
    width: calc(100% - 146px);
  }
  .atag{
    color:#0079FF;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/view/Pesticide03.vue